import React from 'react';
const dimensions = [{
  num: '01',
  name: 'Pedestrian Activity',
  stat: '29M road segments',
  dotColor: '#34d399'
}, {
  num: '02',
  name: 'Walking Infrastructure',
  stat: '100% coverage',
  dotColor: '#60a5fa'
}, {
  num: '03',
  name: 'Pedestrian Safety',
  stat: '85M roads scored',
  dotColor: '#f472b6'
}, {
  num: '04',
  name: 'Terrain Analysis',
  stat: '10cm accuracy',
  dotColor: '#2dd4bf'
}, {
  num: '05',
  name: 'Street Lighting',
  stat: '24/7 analysis',
  dotColor: '#a78bfa'
}, {
  num: '06',
  name: 'Nearby Amenities',
  stat: '3M amenities',
  dotColor: '#fbbf24'
}, {
  num: '07',
  name: 'Transit Access',
  stat: '887K stops',
  dotColor: '#38bdf8'
}];
export function ProductSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-290">
      <div className="flex flex-row w-full h-full min-h-0 relative overflow-hidden" data-id="element-291">
        {/* Left Content — left-aligned text */}
        <div className="flex flex-col justify-center w-[50%] flex-shrink-0 min-h-0 overflow-hidden relative z-10" style={{
        padding: 'var(--slide-padding)',
        paddingLeft: 'clamp(2rem, 6vw, 6rem)'
      }} data-id="element-292">
          {/* Blue italic label — matching other slides */}
          <p className="italic font-semibold animate-fade-slide" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          marginBottom: 'clamp(0.5rem, 1.5vw, 1rem)',
          animationDelay: '0.1s'
        }} data-id="element-293">
            The data behind Navi.
          </p>

          {/* Subtitle */}
          <p className="font-bold text-white animate-fade-slide whitespace-nowrap" style={{
          fontSize: 'clamp(1rem, 2.5vw, 2rem)',
          marginBottom: 'clamp(1rem, 2.5vw, 2rem)',
          animationDelay: '0.15s'
        }} data-id="element-294">
            We've built the missing layer.
          </p>

          {/* Massive two-tone heading */}
          <h1 className="font-black tracking-tight leading-[0.95] animate-fade-slide" style={{
          fontSize: 'clamp(2.5rem, 7vw, 6rem)',
          animationDelay: '0.2s'
        }} data-id="element-295">
            <span className="block text-white" data-id="element-296">85 million streets.</span>
            <span className="block" style={{
            color: 'rgba(255,255,255,0.3)'
          }} data-id="element-297">
              One walkability score.
            </span>
          </h1>

          {/* Body paragraph */}
          <p className="leading-relaxed animate-fade-slide" style={{
          color: 'rgba(255,255,255,0.45)',
          fontSize: 'var(--body-size)',
          maxWidth: 'clamp(280px, 32vw, 480px)',
          marginTop: 'clamp(1.5rem, 3vw, 2.5rem)',
          animationDelay: '0.3s'
        }} data-id="element-298">
            Every street graded across 7 dimensions. Your personal score weighs
            them based on what matters to you.
          </p>
        </div>

        {/* Right Side — Seven Dimensions List */}
        <div className="flex-1 flex flex-col justify-center relative overflow-hidden animate-fade-slide" style={{
        padding: 'clamp(1.5rem, 3vw, 3rem) clamp(1.5rem, 3vw, 3rem)',
        animationDelay: '0.3s'
      }} data-id="element-299">
          {/* 309M Stat — prominent */}
          <div className="flex items-end animate-fade-slide" style={{
          gap: 'clamp(0.5rem, 1vw, 0.75rem)',
          marginBottom: 'clamp(1.25rem, 2.5vw, 2rem)',
          animationDelay: '0.25s'
        }} data-id="element-300">
            <span className="font-black leading-none" style={{
            fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
            fontVariantNumeric: 'tabular-nums',
            color: '#4A90D9'
          }} data-id="element-301">
              309M
            </span>
            <span style={{
            color: 'rgba(255,255,255,0.5)',
            fontSize: 'var(--body-size)',
            paddingBottom: 'clamp(0.2rem, 0.5vw, 0.4rem)'
          }} data-id="element-302">
              data points
            </span>
          </div>

          {/* Section label */}
          <div className="flex items-center" style={{
          gap: 'clamp(0.5rem, 1vw, 1rem)',
          marginBottom: 'clamp(0.75rem, 1.5vw, 1.25rem)'
        }} data-id="element-303">
            <span className="uppercase tracking-[0.2em] font-semibold" style={{
            color: 'rgba(255,255,255,0.35)',
            fontSize: 'clamp(0.55rem, 0.8vw, 0.7rem)'
          }} data-id="element-304">
              Built from seven dimensions
            </span>
            <div className="flex-1" style={{
            height: '1px',
            backgroundColor: 'rgba(255,255,255,0.08)'
          }} data-id="element-305" />
          </div>

          {/* Top border */}
          <div style={{
          height: '2px',
          background: 'linear-gradient(90deg, #4A90D9 0%, rgba(74,144,217,0.1) 100%)',
          marginBottom: 'clamp(0.25rem, 0.5vw, 0.5rem)'
        }} data-id="element-306" />

          {/* Dimension Rows */}
          <div className="flex flex-col" data-id="element-307">
            {dimensions.map((dim, i) => <div key={dim.num} className="animate-fade-slide" style={{
            animationDelay: `${0.35 + i * 0.06}s`
          }} data-id="element-308">
                <div className="flex items-center" style={{
              padding: 'clamp(0.6rem, 1.2vh, 1rem) 0',
              borderBottom: '1px solid rgba(255,255,255,0.06)'
            }} data-id="element-309">
                  {/* Number */}
                  <span className="flex-shrink-0 font-mono" style={{
                color: 'rgba(255,255,255,0.2)',
                fontSize: 'var(--small-size)',
                width: 'clamp(24px, 2.5vw, 36px)'
              }} data-id="element-310">
                    {dim.num}
                  </span>

                  {/* Colored dot */}
                  <div className="flex-shrink-0 rounded-full" style={{
                width: 'clamp(6px, 0.6vw, 9px)',
                height: 'clamp(6px, 0.6vw, 9px)',
                backgroundColor: dim.dotColor,
                marginRight: 'clamp(0.5rem, 1vw, 0.85rem)'
              }} data-id="element-311" />

                  {/* Dimension name */}
                  <span className="font-bold text-white flex-1" style={{
                fontSize: 'clamp(0.85rem, 1.4vw, 1.15rem)'
              }} data-id="element-312">
                    {dim.name}
                  </span>

                  {/* Stat + arrow */}
                  <div className="flex items-center flex-shrink-0" style={{
                gap: 'clamp(0.3rem, 0.5vw, 0.5rem)'
              }} data-id="element-313">
                    <span className="font-mono" style={{
                  color: 'rgba(255,255,255,0.3)',
                  fontSize: 'var(--small-size)'
                }} data-id="element-314">
                      {dim.stat}
                    </span>
                    <span style={{
                  color: 'rgba(255,255,255,0.15)',
                  fontSize: 'var(--small-size)'
                }} data-id="element-315">
                      ›
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}